import { cva } from 'class-variance-authority';

export const buttonStyles = cva(
  [
    'rounded font-medium transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2',
    'px-4 py-2 text-sm',
  ],
  {
    variants: {
      variant: {
        contained: 'bg-brand-primary-500 text-white hover:bg-blue-700',
        outlined:
          'border border-gray-300 bg-transparent text-gray-700 hover:border-gray-500',
        navigation: `flex items-center justify-center gap-1 rounded-[0.4rem] text-center font-[600] outline-none`,
      },
      color: {
        primary: 'bg-action-button text-white hover:bg-blue-700',
        secondary:
          'border-[0.125rem] border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white',
        'navigation-primary': `bg-action-button border-action-button active:bg-action-button-hover active:border-action-focus focus:bg-action-focus hover:bg-action-button-hover border-[0.125rem]
          text-white shadow-[0_2px_6px_0_rgba(0,0,0,0.3)] outline-none
          hover:outline-none focus:text-black
          focus:outline-none active:border-[0.125rem] active:border-solid active:text-white
          active:outline-none
        `,
        'navigation-secondary': `text-action-button border-action-button hover:bg-action-button hover:shadow-[0_0_0.125rem_0.735rem_rgba(0,0,0,0.3 )] focus:bg-action-focus active:bg-action-button-hover active:shadow-action-focus border-[0.125rem] border-solid
          bg-transparent hover:border-[0.125rem] hover:border-solid
          hover:border-transparent hover:text-white hover:outline-none focus:border-[0.125rem] focus:border-solid
          focus:text-black focus:outline-none active:text-white active:shadow-[0_0_0_0.125rem] active:outline-none
        `,
      },
      size: {
        small: 'px-2 py-1 text-xs',
        medium: 'px-4 py-2 text-sm ',
        large: 'px-6 py-3 text-base',
        extraLarge: '!text-bodyLg px-2 py-2 leading-[1.336rem]',
      },
    },
    defaultVariants: {
      color: 'primary',
      size: 'medium',
      variant: 'contained',
    },
    compoundVariants: [
      {
        variant: 'outlined',
        color: 'primary',
        className:
          'border-action-button text-action-button hover:bg-action-button-100 bg-transparent',
      },
      {
        variant: 'outlined',
        color: 'secondary',
        className:
          'border-green-500 bg-transparent text-green-500 hover:bg-green-100',
      },
    ],
  },
);
